import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },
    getters: {
    },
    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },
    actions: {
        //查询list列表
        select(context, payload) {
            payload.type = 'rc/namelist/select'
            // console.log(payload, "payload----------")
            return D.select(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        list: data.list || [],
                        pagination: {
                            total: +data.totalRecords,
                            current: +data.page,
                            pageSize: +data.pageSize,
                        }
                    }
                })
            })
        },
        //查询lishi列表
        lishi(context, payload) {
            payload.type = 'rc/namelist/lishi'
            return D.select(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        list: data.list || [],
                        pagination: {
                            total: +data.totalRecords,
                            current: +data.page,
                            pageSize: +data.pageSize,
                        }
                    }
                })
            })
        },
        //查询zhixing列表
        zhixing(context, payload) {
            payload.type = 'rc/namelist/zhixing'
            return D.select(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        list: data.list || [],
                        pagination: {
                            total: +data.totalRecords,
                            current: +data.page,
                            pageSize: +data.pageSize,
                        }
                    }
                })
            })
        },
        //新增
        add(context, payload) {
            return D.add(payload)
        },
        //修改
        edit(context, payload) {
            return D.edit(payload)
        },
        //删除
        del(context, payload) {
            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'select' })
                return response
            })
        },
        //详情
        detail(context, payload) {
            return D.detail(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
        },
    }
}